/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NftMallItem.vue?vue&type=template&id=c6e1b23e&scoped=true"
import script from "./NftMallItem.vue?vue&type=script&lang=js"
export * from "./NftMallItem.vue?vue&type=script&lang=js"
import style0 from "./NftMallItem.vue?vue&type=style&index=0&id=c6e1b23e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e1b23e",
  null
  
)

export default component.exports